import { FBase } from './firebase.base';
import { Paging } from '../paging';
import { IProjectColors } from '@app/interfaces/project-colors.interface';
import { EmailSettings, IEmailChrome } from '@app/interfaces/email-settings.interface';
import { IBillSettings } from '@app/interfaces/bill-settings.interface';
import { FaviconDTO } from '../dto/favicon.dto';
import { IsNotEmpty } from '@pineapplelab/validators';
import { isObject } from '@pineapplelab/util';
import { IProjectSeo } from '@app/interfaces/project-seo.interface';

export interface IDomainDnsRecord {
  domainName: string;
  type: string;
  rdata: string;
  requiredAction: 'ADD' | 'REMOVE' | 'NONE';
}

export interface IDomainSiteRecord {
  domain: string;
  status: string;
  dnsRecords: IDomainDnsRecord[];
}

export interface IProjectDomainDnsRecords {
  app?: IDomainSiteRecord;
  landing?: IDomainSiteRecord;
  landingWww?: IDomainSiteRecord;
  skipped?: string[];
  updatedAt?: string;
}

export class Project extends FBase {
  fileName: string = null;
  fileSize: string = null;
  logo: string = null;
  name: string = null;
  @IsNotEmpty()
  url: string = null;
  landingUrl: string = null;
  cssFileUrl: string = null;
  favicon: FaviconDTO = null;
  seo: IProjectSeo = {
    title: null,
    description: null,
    ogTitle: null,
    ogDescription: null,
    ogImage: null,
    ogUrl: null,
    keywords: null,
    twitterCard: null,
    twitterImage: null,
  };
  emailSettings?: EmailSettings = null;
  emailChrome?: IEmailChrome = null;
  billSettings?: IBillSettings = null;
  inboundEmailAddress?: string = null;
  testingEmail?: string = null;
  domainDnsRecords?: IProjectDomainDnsRecords = null;
  plan: string = 'BASIC';
  captchaKey: string = null;
  recaptchaDomains: string[] = null;
  colors: IProjectColors = {
    accentColor: "#D1D1D1",
    accentColorDark: "#1C1B20",
    accentColorLight: "#f5f5f5",
    backgroundColor: "#ffffff",
    backgroundColorDark: "#ffffff",
    backgroundColorLight: "#f5f5f5",
    primaryColor: "#FEBA01",
    primaryColorDark: "#dd9c11",
    primaryColorLight: "#f7cf7a",
    warnColor: "#FF4949",
    warnColorDark: "#c50021",
    warnColorLight: "#ff7f75",
    fontFamily: "'Poppins', sans-serif",
    textColor: "#000000",
    textWithPrimaryBackground: "#ffffff",
    textWithWarnBackground: "#ffffff",
    textWithAccentBackground: "#ffffff",
  };

  __fileLogoImage: File;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace Project {
  export const PATH = 'projects';

  export const PAGING = new Paging<Project>(<Paging.IPaging>{
    collection: PATH,
    orderOptions: [{ field: 'name', label: 'name', placeholder: 'Filter by name', dataType: Paging.dataType.string }],
  });
}
